import React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';
import UserInfo from '../session/UserInfo';

const Header = () => {
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h5" color="inherit" sx={{ flex: 1, textAlign: 'left' }}>
          Gatekeeper
        </Typography>

        <UserInfo />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
